import { Register } from "./Register";

export function NurseSignup() {
  return <Register />;
}
